import { fork } from "redux-saga/effects";

import watchClosewordState from "./saleorder/saga"
import watchCustomerState from "./customer/saga"

const watchSaleorderDataMangement = [
  fork(watchClosewordState),
  fork(watchCustomerState)
];

export default watchSaleorderDataMangement;
